
import { Component, OnInit, NgZone, HostListener, ViewChild } from '@angular/core';

import { ListingBaseComponent } from 'src/core/sharepoint/model/listingbase-component';
import { RepositoryService } from 'src/core/sharepoint/services/repository';
import { TranslateService } from '@ngx-translate/core';
import { Language, Mode } from 'src/core/utility/enums/enums';
import { quickLinksConstants } from '../../models/quick-links-const';
import { QuickLinksMapper } from '../../models/quick-links-mapper';
import { MapperCONFIG } from 'src/core/sharepoint/model/mapper';
import { LoadingScreenService } from 'src/core/components/loader/services/loader.service';
import { CarouselComponent, SlidesOutputData } from 'ngx-owl-carousel-o';
import { ExtractSourcePipe } from 'src/core/sharepoint/pipes/extractSource.pipe';


@Component({
  selector: 'adahi-quick-links',
  templateUrl: './quick-links.component.html',
  providers:[
    RepositoryService,
    { provide: MapperCONFIG, useClass: QuickLinksMapper },
  ]
})
export class QuickLinksComponent extends ListingBaseComponent implements OnInit {

  carouselcustomOptions: any;
  @ViewChild('owlCar') owlCar: CarouselComponent;
  activeSlides: SlidesOutputData;
  slidesStore: any[];
  resizeFlag = true;
  

  constructor(private repositoryService: RepositoryService, ngZone: NgZone, translate: TranslateService,public LoadingScreenService:LoadingScreenService) {
    super( ngZone, translate,LoadingScreenService);
    this.carouselOptions();
  }

  ngOnInit() {
    this.LoadingScreenService.startLoading();
    this.translate.getTranslation(this.translate.defaultLang).subscribe((res) => {
      this.repositoryService.getItems(quickLinksConstants.slash, this.translate.instant('quickLinks.QuickLinksList'), quickLinksConstants.camlQuery.quickLinksHome, this.onSuccess, this.onError, this.onNoAvailableData);
    });
  }

  onSuccess = (list: Array<any>) => {
    //alert('base');
    this.ngZone.run(() => {
        this.LoadingScreenService.stopLoading();
        this.status = Mode.Success;
        //this.list = list;
        let extractSourcePipe = new ExtractSourcePipe();
        list.forEach(element => {
          element.logo = extractSourcePipe.transform(element.logo,[]);
          this.list.push(element);
        });
        this.total = list.length;
    });

}
  
  getData(data: SlidesOutputData) {
    this.activeSlides = data;
  }


  @HostListener('window:resize')
  onResize() {
    //ngZone.run will help to run change detection
    this.ngZone.run(() => {
      this.resizeFlag = false;
    });
    this.ngZone.run(() => {
      this.resizeFlag = true;
    });
 }
  
  carouselOptions() {
    if (Language[_spPageContextInfo.currentLanguage] == 'ar') {
      this.carouselcustomOptions = {
        rtl: true,
        loop: false,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        nav: true,
        dots: false,
        navText: ["<i class='icon-arrow-right'></i>", "<i class='icon-arrow-left'></i>"],
        autoWidth: true,
        margin: 5,
        autoplay: false,
        autoplayTimeout: 99999999,
        items: 5
      }
    } else {
      this.carouselcustomOptions = {
        loop: false,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        nav: true,
        dots: false,
        navText: ["<i class='icon-arrow-right'></i>", "<i class='icon-arrow-left'></i>"],
        autoWidth: true,
        margin: 5,
        autoplay: false,
        autoplayTimeout: 99999999,
        items: 5
      }
    }

  }
 
}